import HistoryChangeRemainTabStore from "../FeeTab/Tabs/HistoryChangeRemainTab/HistoryChangeRemainTabStore";
import HistoryDepositStore from "../FeeTab/Tabs/HistoryDepositTab/HistoryDepositStore";
import ServiceFeeTabStore from "../FeeTab/Tabs/ServiceFeeTab/ServiceFeeTabStore";

export const FeeStore = {
  serviceFeeTabStore: new ServiceFeeTabStore(),
  historyDepositStore: new HistoryDepositStore(),
  historyChangeRemainTabStore: new HistoryChangeRemainTabStore(),
};
